import { DEFAULT_CACHE_TTL } from '@/constants';
import * as Actions from '../types/cache';
import { createAction } from '../utils';
export const addCacheEntry = (key, data, expires = Date.now() + DEFAULT_CACHE_TTL) => (createAction(Actions.ADD_CACHE_ENTRY, { key, data, expires }));
export const clearCache = () => createAction(Actions.CLEAR_CACHE);
export const purgeExpiredCacheEntries = (time = Date.now()) => (createAction(Actions.PURGE_EXPIRED_CACHE_ENTRIES, time));
